<template>
  <div class="reservePlanBox">
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <Button type="primary" @click="handleAdd()">新建</Button>
        <i-input v-model="searchParam"
          placeholder="请输入名称/编号"
          clear
          style="width: 15%;margin-right: 20px;">
          <i-button type="primary"
            icon="ios-search"
            slot="append"
            @click="getReservePlanData(1)"></i-button>
        </i-input>
      </div>
      <div style="margin-top: 15px;">
        <Table border :columns="tableTitleData" :data="reserveData">
          <template slot-scope="{ row }" slot="planNum">
            <el-link type="primary"
              size="mini"
              @click.native.prevent="showData(row)"><span>{{ row.planNum }}</span>
            </el-link>
          </template>
          <template slot-scope="{ row }" slot="planType">
            <span>{{ row.planType }}</span>
          </template>
          <template slot-scope="{ row }" slot="plannerDep">
            <span v-if="row.departmentVo">{{ row.departmentVo.name }}</span>
          </template>
          <template slot-scope="{ row }" slot="dangerType">
            <!-- <Tooltip content="甲类车间（非重大危险源）" placement="top-start">
              <span v-if="row.dangerType == '0'">甲类车间</span>
            </Tooltip>
            <Tooltip content="埋地储罐区（非重大危险源）" placement="top-start">
              <span v-if="row.dangerType == '1'">埋地储罐区</span>
            </Tooltip>
            <Tooltip content="甲类仓库（非重大危险源）" placement="top-start">
              <span v-if="row.dangerType == '2'">甲类仓库</span>
            </Tooltip> -->
            {{ row.dangerType }}
          </template>
          <template slot-scope="{ row }" slot="planLevel">
            <el-tag type="success" size="small" v-if="row.planLevel == '0'">公司级</el-tag>
            <el-tag type="success" size="small" v-if="row.planLevel == '1'">分厂级</el-tag>
            <el-tag type="success" size="small" v-if="row.planLevel == '2'">车间级</el-tag>
          </template>
          <template slot-scope="{ row }" slot="implementationTime">
            <span>{{ row.implementationTime | timeFilter }}</span>
          </template>
          <template slot-scope="{ row }" slot="gmtModified">
            <span>{{ row.gmtModified | timeFilter }}</span>
          </template>
          <template slot-scope="{ row }" slot="status">
            <el-tag type="danger" size="small" v-if="row.status === 0">待发布</el-tag>
            <el-tag type="success" size="small" v-else-if="row.status == 1">已发布</el-tag>
            <el-tag type="warning" size="small" v-else-if="row.status == 2">编制中</el-tag>
            <el-tag type="warning" size="small" v-else-if="row.status == 3">评审中</el-tag>
            <el-tag type="danger" size="small" v-else-if="row.status == 4">修订中</el-tag>
            <el-tag type="info" size="small" v-else-if="row.status == 5">已作废</el-tag>
            <el-tag type="danger" size="small" v-else>已驳回</el-tag>
            <!-- <el-tag type="success" size="small" v-if="row.status">{{ statusList[row.status] }}</el-tag> -->
          </template>
          <template slot-scope="{ row }"  slot="action">
            <el-link type="primary"
              size="small"
              :underline="false"
              v-if="row.status == '2' || row.status == '4'"
              @click="updateStatus(row,3)"
              style="margin-right: 5px">提交审核</el-link>
            <el-link type="primary"
              size="small"
              :underline="false"
              v-if="row.status == '2' || row.status == '4'"
              @click="handChange(row,3)"
              style="margin-right: 5px">编辑</el-link>
            <el-link type="danger"
              size="small"
              :underline="false"
              v-if="row.status == '2' || row.status == '4'|| row.status == '6'"
              @click="delReservePlanData(row)"
              style="margin-right: 5px">删除</el-link>
            <el-link type="primary"
              size="small"
              :underline="false"
              v-if="row.status == '3' && row.checkUserIds.indexOf(userId)>-1"
              @click="handChange(row,1)"
              style="margin-right: 5px">审核</el-link>
            <el-link type="warning"
              size="small"
              :underline="false"
              v-if="row.status == '0'"
              @click="updateStatus(row,1)"
              style="margin-right: 5px">发布</el-link>
            <el-link type="primary"
              size="small"
              :underline="false"
              v-if="row.status == '1'"
              @click="handChange(row,2)"
              style="margin-right: 5px">修订</el-link>
            <el-link type="info"
              size="small"
              :underline="false"
              v-if="row.status == '1'"
              @click="updateStatus(row,5)"
              style="margin-right: 5px">作废</el-link>
            <el-link type="info"
              size="small"
              :underline="false"
              v-if="row.status == '5'"
              @click="updateStatus(row,2)"
              style="margin-right: 5px">恢复</el-link>
          </template>
        </Table>
        <!-- 分页 -->
        <Page style="float: right;margin-top: 10px;"
          :total="total"
          :page-size="sizePage"
          @on-change="getReservePlanData" />
      </div>

    </div>
    <el-drawer :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      :show-close="false"
      size="60%">
      <div slot="title" class="drawerTitle">
          <p>名称：{{ infoForm.planName }}
          <i class="el-icon-circle-close" @click="handleClose"></i>
        </p>
        <div class="tWord">
          <div><p>预案编号</p><span>{{ infoForm.planNum }}</span></div>
          <div><p>预案类型</p>
            <span>{{ infoForm.planType }}</span>
          </div>
          <div><p>创建时间</p><span>{{ infoForm.gmtCreate }}</span></div>
        </div>
      </div>
      <div class="drawerBody">
        <el-tabs v-model="activeName">
          <el-tab-pane label="详情" name="a"></el-tab-pane>
        </el-tabs>
        <div class="bodyInner">
          <el-form :inline="true"
            :model="infoForm"
            class="demo-form-inline"
            style="background-color: white;width: 100%">
            <el-form-item label="编号：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.planNum}}</span>
            </el-form-item>
            <el-form-item label="名称：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.planName}}</span>
            </el-form-item>
            <el-form-item label="预案类型：" style="width: 40%;margin-left: 8%">
              <span>{{ infoForm.planType }}</span>
            </el-form-item>
            <el-form-item label="危险源：" style="width: 40%;margin-left: 5%">
              <el-tag type="success" size="small" v-if="infoForm.dangerType == '0'">甲类车间（非重大危险源）</el-tag>
              <el-tag type="success" size="small" v-if="infoForm.dangerType == '1'">埋地储罐区（非重大危险源）</el-tag>
              <el-tag type="success" size="small" v-if="infoForm.dangerType == '2'">甲类仓库（非重大危险源）</el-tag>
            </el-form-item>
            <el-form-item label="级别：" style="width: 40%;margin-left: 8%">
              <el-tag type="success" size="small" v-if="infoForm.planLevel == '0'">公司级</el-tag>
              <el-tag type="success" size="small" v-if="infoForm.planLevel == '1'">分厂级</el-tag>
              <el-tag type="success" size="small" v-if="infoForm.planLevel == '2'">车间级</el-tag>
            </el-form-item>
            <el-form-item label="编写人：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.creatorName}}</span>
            </el-form-item>
            <el-form-item label="编写部门：" style="width: 40%;margin-left: 8%">
              <span size="small" v-if="infoForm.departmentVo">{{infoForm.departmentVo.name}}</span>
            </el-form-item>
            <el-form-item label="发布实施日期：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.implementationTime}}</span>
            </el-form-item>
            <el-form-item label="附件：" style="width: 90%;margin-left: 8%">
              <el-link v-for="(item1,index) in planFile"
                type="primary"
                :key="index"
                @click="downloadBtn(item1)">{{item1.fileName}}&nbsp;&nbsp;&nbsp;</el-link>
            </el-form-item>
            <el-form-item label="审核：" style="width: 90%;margin-left: 8%">
              <el-tag type="success" size="small" v-if="infoForm.status === 0 || infoForm.status === 1">已审核</el-tag>
              <el-tag type="danger" size="small" v-if="infoForm.status === 2">待提交审核</el-tag>
              <el-tag type="danger" size="small" v-if="infoForm.status === 3">待审核</el-tag>
              <el-tag type="warning" size="small" v-if="infoForm.status === 4">修订中</el-tag>
              <el-tag type="info" size="small" v-if="infoForm.status === 5">已作废</el-tag>
              <el-tag type="info" size="small" v-if="infoForm.status === 6">已驳回</el-tag>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { downLoadDocument } from '@/api/downLoad'
//新增编辑router,addreservePlan。addreservePlan.vue文件无用，该功能完成后可删除该文件
export default {
  data() {
    return {
      active: 1,
      activeName: 'a',
      planFile: [],
      infoForm: {
        departmentVo: { name: '' }
      },
      drawer: false,
      total: 10,
      sizePage: 10,
      currentPage: 1,
      searchParam: '',
      userId: '',
      tableTitleData: [
        { title: '编号', slot: 'planNum', width: '80' },
        { title: '名称', key: 'planName' },
        { title: '类型', slot: 'planType' },
        { title: '危险源', slot: 'dangerType', tooltip: true },
        { title: '区域', key: 'locationName', tooltip: true },
        { title: '级别', slot: 'planLevel' },
        { title: '编写人', key: 'editorName' },
        { title: '编写部门', slot: 'plannerDep' },
        { title: '发布实施时间', slot: 'implementationTime' },
        { title: '修改日期', slot: 'gmtModified' },
        { title: '创建者', key: 'creatorName' },
        { title: '状态', slot: 'status' },
        { title: '操作', slot: 'action' }
      ],
      statusList: ['待发布','已发布','编制中','评审中','修订中','已作废','已驳回'],
      reserveData: [],
      checkUsers: []
    }
  },
  created() {},
  methods: {
    showData(row) {
      this.planFile = []
      this.infoForm = row
      this.componentsMoudel.httpRequest
        .getRequestHander('/planManagement/info/' + row.id)
        .openLoad()
        .startGet()
        .then(res => {
          this.infoForm = res.body.data
          this.locationIds = this.infoForm.locationIds
          this.checkUsers = this.infoForm.checkUserIdList
          // let files = JSON.parse(this.infoForm.planFile);
          if (this.infoForm.planFile) {
            this.planFile = JSON.parse(this.infoForm.planFile)
          }
          // if (files){
          //     for (var i = 0; i < files.length; i++) {
          //         let myFile = {};
          //         var file = files[i];
          //         myFile.response = {};
          //         myFile.response.data = file.url;
          //         myFile.name = file.fileName;
          //         this.planFile.push(myFile);
          //     }
          // }
        })

      this.drawer = true
    },
    handleClose() {
      this.drawer = false
    },
    handleAdd() {
      this.$router.push({
        path: 'addreservePlan'
      })
    },
    handChange(row, id) {
      this.$router.push({
        name: 'addreservePlan',
        params: {
          key: row,
          id: id
        }
      })
    },
    getMySelf() {
      const that = this
      this.componentsMoudel
        .getRequestHander(this.componentsMoudel.getData('urls').userInfo)
        .startGet()
        .then(res => {
          that.componentsMoudel.setData('userData', res.body.data)
          that.userId = res.body.data.id
        })
    },
    getReservePlanData: function(page) {
      this.currentPage = page
      const that = this
      const data = {}
      data.searchParam = this.searchParam
      data.curPage = page
      data.limit = this.sizePage
      this.componentsMoudel
        .startPost('/planManagement/list_all', data)
        .then(res => {
          that.reserveData = res.body.data
          that.total = res.body.cum
          // that.currentPage = res.body.page;
        })
    },
    delReservePlanData: function(data) {
      const that = this
      this.componentsMoudel
        .startPost('/planManagement/delete/' + data.id)
        .then(res => {
          if (this.reserveData.length <= 1 && this.currentPage > 1) {
            this.currentPage -= 1
          }
          that.getReservePlanData(that.currentPage)
        })
    },
    updateStatus(row, status) {
      let formData = new FormData()
      formData.append('id', row.id)
      formData.append('status', status)
      this.componentsMoudel.httpRequest
        .getRequestHander('/planManagement/updateStatus')
        .openLoad()
        .startPost(formData)
        .then(res => {
          if (res.body.status_code == 100) {
            this.getReservePlanData(1)
          } else {
            this.$message.error('操作失败')
          }
        })
    },
    // 下载文件
    downloadBtn(item) {
      console.log(item.url, item.fileName)
      downLoadDocument(item.url, item.fileName)
    }
  },
  mounted: function() {
    this.getReservePlanData(this.currentPage)
    this.getMySelf()
  }
}
</script>

<style scoped>
/* <!--         抽屉样式           --> */
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 120px;
  padding-left: 15px;
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.el-drawer__header {
  padding: 0;
  margin-bottom: 0
}
/* 解决tab切换会有蓝色边框的问题 */ 
.reservePlanBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
  box-shadow: none;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 160px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
}
</style>
